import {TableSettings} from "../../../tableSettings";

export const aesInfoTable: TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'scroll',
  // 
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'D/F',
      accessor: 'qualifier',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'Schedule B',
      accessor: 'code',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.7,
    },
    {
      Header: 'Description',
      accessor: 'marks',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.05,
    },
    {
      Header: 'Qty',
      accessor: 'qtY1',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Unit',
      accessor: 'uniT1',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Qty2',
      accessor: 'qtY2',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Unit',
      accessor: 'uniT2',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'USD Value',
      accessor: 'price',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'KGS',
      accessor: 'kgs',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    { 
      Header: '', 
      accessor: 'scroll', 
      resizable: false, 
      sortable: false, 
      visible: true, 
      initialWidthPercentage: 2.94, 
    },
  ]
};

export const vehInfoTable: TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  // 
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'VEH ID #',
      accessor: 'vehid',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25,
    },
    {
      Header: 'Qual.',
      accessor: 'vehidqual',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Title #',
      accessor: 'titleno',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 44.11,
    },
    {
      Header: 'Title State',
      accessor: 'titlestate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.7,
    },
    { 
      Header: '', 
      accessor: 'scroll', 
      resizable: false, 
      sortable: false, 
      visible: true, 
      initialWidthPercentage: 2.94, 
    },
  ]
};

export const correctionNoticeTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '100px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Item',
      accessor: 'item',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 29.41,
    },
    {
      Header: 'Now Read',
      accessor: 'before',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 33.82,
    },
    {
      Header: 'Should Read',
      accessor: 'after',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 33.82,
    },
    { 
      Header: '', 
      accessor: 'scroll', 
      resizable: false, 
      sortable: false, 
      visible: true, 
      initialWidthPercentage: 2.94, 
    },
  ]
};

export const arrivalNoticeTable: TableSettings = {
  tableVersion: 10042,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'HBL or HAWB',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.26,
    },
    {
      Header: 'Customer',
      accessor: 'customerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.59,
    },
    {
      Header: 'Fax',
      accessor: 'hasCustomerFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.72,
    },
    {
      Header: 'Email',
      accessor: 'hasCustomerEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.72,
    },
    {
      Header: 'Broker',
      accessor: 'brokerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 21.06,
    },
    {
      Header: 'Fax',
      accessor: 'hasBrokerFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.72,
    },
    {
      Header: 'Email',
      accessor: 'hasBrokerEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.72,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 2.50,
    },
  ]
};

export const mblMemoListTable: TableSettings = {
  tableVersion: 10042,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '100px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    // {
    //   Header: '',
    //   accessor: 'indicator',
    //   resizable: false,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 4.41,
    // },
    {
      Header: 'Date',
      accessor: 'f_U2Date',
      resizable: false,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 14.71,
    },
    {
      Header: 'Type',
      accessor: 'f_Type',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 8.82,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Number',
      accessor: 'f_BlNo',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 14.70,
      initialWidthPercentage: 14.71,
    },
    {
      Header: 'Subject',
      accessor: 'f_Title',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 25,
      initialWidthPercentage: 23.53,
    },
    {
      Header: 'Modified by',
      accessor: 'f_U2ID',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Created by',
      accessor: 'f_U1ID',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Create Date',
      accessor: 'f_U1Date',
      resizable: true,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 11.76,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      // initialWidthPercentage: 11.76,
      initialWidthPercentage: 2.95,
    },
  ]
};

export const hblMemoListTable: TableSettings = {
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '100px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Date',
      accessor: 'date',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Type',
      accessor: 'type',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: '#',
      accessor: 'no',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Subject',
      accessor: 'subject',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'Modified by',
      accessor: 'modifiedBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Created by',
      accessor: 'createdBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Create Date',
      accessor: 'createDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
  ]
};

export const pickupDeliveryTable: TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Trucking Vendor',
      accessor: 'truckingCo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.58,
    },
    {
      Header: 'Pickup Ref. #',
      accessor: 'pickupRef',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Pickup Date',
      accessor: 'pickupDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.26,
    },
    {
      Header: 'Pickup At',
      accessor: 'pickupAt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.68,
    },
    {
      Header: 'Delivery Date',
      accessor: 'deliveryDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:  11.26,
    },
    {
      Header: 'Delivery To',
      accessor: 'deliveryTo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:  15.68,
    },
    {
      Header: 'User',
      accessor: 'c4',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.32,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
  ]
};

export const deliveryOrderTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '66px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  noHeaders: true,
  columns: [
    {
      Header: '',
      accessor: 'c1',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 43,
    },
    {
      Header: '',
      accessor: 'c2',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 54.12,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
  ]
};

export const certificateOfOriginTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Mark and Numbers',
      accessor: 'mark',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.47,
    },
    {
      Header: 'Qty',
      accessor: 'markPkg',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Description of Packages and Goods',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 38.25,
    },
    {
      Header: 'Weight',
      accessor: 'markGross',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Measurement',
      accessor: 'markMeasure',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
  ]
};

export const certificateOfOriginTable_Canada: TableSettings = {
  tableVersion: 10000,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Mark and Numbers',
      accessor: 'mark',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.47,
    },
    {
      Header: 'Description of Packages and Goods',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 38.25,
    },
    {
      Header: 'Qty',
      accessor: 'markPkg',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.64,
    },
    {
      Header: 'Weight',
      accessor: 'markGross',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.64,
    },
  ]
};

export const certificateOfOriginTable_Air: TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '150px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Mark and Numbers',
      accessor: 'mark',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.47,
    },
    {
      Header: 'Qty',
      accessor: 'markPkg',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Description of Packages and Goods',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 38.25,
    },
    {
      Header: 'G. Weight',
      accessor: 'markGross',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Chrg. Weight',
      accessor: 'markMeasure',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
  ]
};

export const bankDraftTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '42px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'BILLS OF LADING',
      accessor: 'c1',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.33,
    },
    {
      Header: 'B/L COPY',
      accessor: 'c2',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'COMM. INV',
      accessor: 'c3',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'INS. CTF.',
      accessor: 'c4',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'CTF. ORG.',
      accessor: 'c5',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'PACKING LIST',
      accessor: 'c6',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'CONS. INV.',
      accessor: 'c7',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
    {
      Header: 'WEIGHT CTF.',
      accessor: 'c8',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.66,
    },
  ]
};

export const shippingAdviceMoreTable: TableSettings = {
  tableVersion: 10042,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.66,
    },
    {
      Header: 'HBL or HAWB',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 37.77,
    },
    {
      Header: 'Customer',
      accessor: 'customerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 51.11,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.44,
    },
  ]
};

export const sendBlTable: TableSettings = {
  tableVersion: 10044,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Select',
      accessor: 'isChecked',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'HBL #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.65,
    },
    {
      Header: 'Shipper',
      accessor: 'shipperName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.53,
    },
    {
      Header: 'Consignee',
      accessor: 'consigneeName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.53,
    },
    {
      Header: 'Notify',
      accessor: 'notifyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.53,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const batchPrintTable: TableSettings = {
  tableVersion: 10043,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'Invoice #',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.70,
    },
    {
      Header: 'Date',
      accessor: 'invoiceDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Invoice To',
      accessor: 'sName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.06,
    },
    {
      Header: 'Salesperson',
      accessor: 'salseperson',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.71,
    },
    {
      Header: 'Amount',
      accessor: 'invoiceAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Fax',
      accessor: 'useFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Email',
      accessor: 'useEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.95,
    },
  ]
};

export const bankEdiTable: TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Type',
      accessor: 'type',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.70,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 61.76,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const batchCheckProcessingVendorTable: TableSettings = {
  tableVersion: 1006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Select',
      accessor: 'select',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Bill #',
      accessor: 'billNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.70,
    },
    {
      Header: 'Bill Date',
      accessor: 'invoiceDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.58,
    },
    {
      Header: 'Vendor',
      accessor: 'payToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.64,
    },
    {
      Header: 'Seq #',
      accessor: 'checkSeq',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const batchCheckProcessingCheckTable: TableSettings = {
  tableVersion: 1010,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Seq #',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.70,
    },
    {
      Header: 'Pay to Order',
      accessor: 'payToOrderName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 48.34,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.51,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.51,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const batchStatementProcessingTable: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '344px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.5, },
    { Header: 'Customer', accessor: 'billToSName', resizable: false, sortable: false, visible: true, initialWidthPercentage: 19.5, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, },
    { Header: 'Overdue', accessor: 'maxOverDueDays', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6, },
    { Header: 'Paid Date', accessor: 'lastPaidDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8, },
    { Header: 'Currency Balance', accessor: 'currentAmount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 10, },
    { Header: 'Past Due Amount', accessor: 'pastDueAmount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 10, },
    { Header: 'Count', accessor: 'pastDueCount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, },
    { Header: 'Total Amount', accessor: 'totalAmount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Email', accessor: 'useEmail', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, },
    { Header: 'Select', accessor: 'select', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, },
    { Header: 'Status', accessor: 'status', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.5, },
    { Header: 'Action', accessor: 'action', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.5, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2, },
  ]
};

export const historyViewMainDetailTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.57,
    },
    {
      Header: 'Date',
      accessor: 'ediDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.90,
    },
    {
      Header: 'User',
      accessor: 'ediId',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.52,
    },
    {
      Header: 'Action',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.52,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.76,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.52,
    },
    {
      Header: 'Entity #',
      accessor: 'invoNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.90,
    },
    {
      Header: 'Entity Date',
      accessor: 'invoDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.52,
    },
    {
      Header: 'Due Date',
      accessor: 'dueDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.52,
    },
    {
      Header: 'Customer',
      accessor: 'custName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.86,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.41,
    },
  ]
};

export const historyViewBillingDetailTable: TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'scroll',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Seq. #',
      accessor: 'seqNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.23,
    },
    {
      Header: 'Type',
      accessor: 'chgTypeDesc',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.38,
    },
    {
      Header: 'Billing Code',
      accessor: 'code',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.08,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30.77,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.15,
    },
    {
      Header: 'USD Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.31,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.08,
    },
  ]
};

export const historyViewRevisionTable: TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '*',
      accessor: 'printa',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.00,
    },
    {
      Header: 'Date',
      accessor: 'u2Date',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 33.33,
    },
    {
      Header: 'Entity #',
      accessor: 'invoNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 41.67,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.49,
    },
  ]
};

export const paymentHistoryTable: TableSettings = {
  tableVersion: 10078,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
    {
      Header: 'P. Type',
      accessor: 'pType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'Accrual Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.5,
    },
    {
      Header: 'Entity',
      accessor: 'receivedFrom',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.5,
    },
    {
      Header: 'Check #/Ref. #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.5,
    },
    {
      Header: 'Bank',
      accessor: 'bank',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.5,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.5,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.5,
    },
    {
      Header: 'Void',
      accessor: 'void',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },

    {
      Header: 'Draft',
      accessor: 'isDraft',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.49,
    },
  ]
};

export const deleteHistoryTable: TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
    {
      Header: 'Delete Date',
      accessor: 'actionDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Delete By',
      accessor: 'actionBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'MBL #',
      accessor: 'blNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Loading Port',
      accessor: 'pol',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: 'ETD',
      accessor: 'etd',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Discharge Port',
      accessor: 'pod',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: 'ETA',
      accessor: 'eta',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Agent',
      accessor: 'agentName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.93,
    },
  ]
};

export const deleteHistoryTable_BTLoad: TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
    {
      Header: 'Delete Date',
      accessor: 'actionDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Delete By',
      accessor: 'actionBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Load #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Load Date',
      accessor: 'etd',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Carrier',
      accessor: 'pol',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: 'Broker',
      accessor: 'pod',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: 'Truck #',
      accessor: 'blNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Departure',
      accessor: 'eta',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Company',
      accessor: 'agentName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.42,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.93,
    },
  ]
};

export const deleteHistoryTable_BTOrder: TableSettings = {
  tableVersion: 10049,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
    {
      Header: 'Delete Date',
      accessor: 'actionDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Delete By',
      accessor: 'actionBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'PRO #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Pickup Location',
      accessor: 'agentName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.62,
    },
    {
      Header: 'Origin',
      accessor: 'pol',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: 'Departure',
      accessor: 'etd',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Destination',
      accessor: 'pod',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: 'Arrival',
      accessor: 'eta',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Bill To',
      accessor: 'comName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.93,
    },
  ]
};

export const deleteHistoryTable_BTDo: TableSettings = {
  tableVersion: 10052,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
    {
      Header: 'Delete Date',
      accessor: 'actionDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'Delete By',
      accessor: 'actionBy',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'D/O #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.62,
    },
    {
      Header: 'D/O Date',
      accessor: 'etd',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Issuer',
      accessor: 'pol',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: 'Carrier',
      accessor: 'pod',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: 'Pickup Location',
      accessor: 'agentName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.62,
    },
    {
      Header: 'P/U Date',
      accessor: 'eta',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'Deliver To',
      accessor: 'comName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.42,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.93,
    },
  ]
};

export const myMemoTable: TableSettings = {
  tableVersion: 10044,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '50px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.88,
    },
    {
      Header: '',
      accessor: 'editParam',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.55,
    },
    {
      Header: 'Remind Date',
      accessor: 'remindDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:11.69,
    },
    {
      Header: 'Due Date',
      accessor: 'dueDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.69,
    },
    {
      Header: 'Type',
      accessor: 'opType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.55,
    },
    {
      Header: 'Refernce',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.71,
    },
    {
      Header: 'Subject',
      accessor: 'mTitle',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27.6,
    },
    {
      Header: 'Create By',
      accessor: 'mU1ID',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.71,
    },
    {
      Header: 'Create Date',
      accessor: 'mU1Date',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.69,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.93,
    },
  ]
};

export const edi310BatchTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.68,
    },
    {
      Header: 'Invoice #',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.35,
    },
    {
      Header: 'Date',
      accessor: 'invoiceDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.13,
    },
    {
      Header: 'Due Date',
      accessor: 'dueDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.13,
    },
    {
      Header: 'Last Send Date',
      accessor: 'ediDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19.35,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.13,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.23,
    },
  ]
};

export const sendShipmentStatusContainerTable: TableSettings = {
  tableVersion: 10050,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '130px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.29,
    },
    {
      Header: 'Container #',
      accessor: 'containerNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 48.62,
    },
    {
      Header: 'ISO Type',
      accessor: 'isoType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 31.57,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.52,
    },  
  ]
};

export const sendShipmentStatusTable: TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '260px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Select',
      accessor: 'checked',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Event',
      accessor: 'eventDesc',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.59,
    },
    {
      Header: 'Date',
      accessor: 'eventSendDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Time',
      accessor: 'eventSendTime',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.35,
    },
    {
      Header: 'Location Code',
      accessor: 'loc',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Location Name',
      accessor: 'locName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.65,
    },
    {
      Header: 'Last Event Date',
      accessor: 'lastSentEventDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.76,
    },
    {
      Header: 'Time',
      accessor: 'lastSentEventTime',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.35,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.96,
    },  
  ]
};

export const historyViewPaymentMainTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.59,
    },
    {
      Header: 'Date',
      accessor: 'historyDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.62,
    },
    {
      Header: 'User',
      accessor: 'historyUser',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.90,
    },
    {
      Header: 'Action',
      accessor: 'historyAction',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.90,
    },
    {
      Header: 'Bank Entity',
      accessor: 'cardBank',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.93,
    },
    {
      Header: 'Accrual Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.90,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.90,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.45,
    },
    {
      Header: 'Ex. rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.17,
    },
    {
      Header: 'Block',
      accessor: 'block',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.45,
    },
    {
      Header: 'Draft',
      accessor: 'draft',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.45,
    },
    {
      Header: 'Received From',
      accessor: 'custName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.93,
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.34,
    },
    {
      Header: 'Deposit Total',
      accessor: 'totalAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.76,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.71,
    },
  ]
};

export const historyViewPaymentDetailsTable: TableSettings = {
  tableVersion: 10046,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.49,
    },
    {
      Header: 'Status',
      accessor: 'status',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.30,
    },
    {
      Header: 'Customer',
      accessor: 'customer',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.93,
    },
    {
      Header: 'Invoice Date',
      accessor: 'invoiceDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.30,
    },
    {
      Header: 'Invoice #',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.63,
    },
    {
      Header: 'Account Code',
      accessor: 'accountCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.44,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.95,
    },
    {
      Header: 'Received Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.63,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.33,
    },
  ]
};

export const billInformationTable: TableSettings = {
  tableVersion: 10010,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '180px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 58.9,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 32,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.08,
    },
  ]
};

export const profitDetailTable: TableSettings = {
  tableVersion: 10011,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '180px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 31.6,
    },
    {
      Header: 'Revenue',
      accessor: 'revenue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.9,
    },
    {
      Header: 'Cost',
      accessor: 'cost',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.9,
    },
    {
      Header: 'CrDb',
      accessor: 'crDbAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.9,
    },
    {
      Header: 'Margin',
      accessor: 'margin',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.9,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.08,
    },
  ]
};

export const accountBalanceTable:TableSettings = {
  tableVersion: 10006,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '550px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'lightgray',
  columns: [
    {
      Header: 'Account',
      accessor: 'glDesc',
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.18,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.69,
    },
    {
      Header: 'AAA 2023',
      accessor: 'amount1',
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.82,
    },
    {
      Header: 'BBB 2023',
      accessor: 'amount2',
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.82,
    },
    {
      Header: 'CCC 2023',
      accessor: 'amount3',
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.82,
    },
    {
      Header: 'Over 3 Months',
      accessor: 'amountOld',
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.82,
    },
    {
      Header: 'Total',
      accessor: 'amountTot',
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.18,
    },
    {
      Header: ' ',
      accessor: 'scroll',
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.78,
    },
  ]
};

export const pendingArApTable: TableSettings = {
  tableVersion: 10002,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '550px',
  useStorage: true,
  flexResizer: false,
  columns: [
    {
      Header: 'Vendor',
      accessor: 'entityName',
      sortable: false,
      visible: true,
      initialWidthPercentage: 45,
    },
    {
      Header: 'Type',
      accessor: 'glDesc',
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.22,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Total',
      accessor: 'balance',
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: ' ',
      accessor: 'scroll',
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.78,
    },
  ]
};

export const volumeByCargoTypeYearsTable:TableSettings = {
  tableVersion: 10003,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '550px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'lightgray',
  columns: [
    {
      Header: 'TYPE',
      accessor: 'type',
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.5,
    },
    {
      Header: 'YEAR5',
      accessor: 'amount5',
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.5,
    },
    {
      Header: 'YEAR4',
      accessor: 'amount4',
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.5,
    },
    {
      Header: 'YEAR3',
      accessor: 'amount3',
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.5,
    },
    {
      Header: 'YEAR2',
      accessor: 'amount2',
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.5,
    },
    {
      Header: 'YEAR1',
      accessor: 'amount1',
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.5,
    },
  ]
};

export const deleteHistoryPaymentTable: TableSettings = {
    tableVersion: 10008,
    overflowX: 'hidden',
    overflowY: 'scroll',

    height: '120px',
    useStorage: true,
    flexResizer: true,

    headersColor: 'white',
    columns: [
        { Header: '', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2, },
        { Header: 'Date', accessor: 'historyDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7.5, },
        { Header: 'User', accessor: 'historyUser', resizable: true, sortable: false, visible: true, initialWidthPercentage: 6.5, },
        { Header: 'Action', accessor: 'historyAction', resizable: true, sortable: false, visible: true, initialWidthPercentage: 4.5, },
        { Header: 'Accrual Date', accessor: 'postDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 6, },
        { Header: 'Customer', accessor: 'billToName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
        { Header: 'Received From', accessor: 'receivedFromName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
        { Header: 'Payment', accessor: 'payType', resizable: true, sortable: false, visible: true, initialWidthPercentage: 4, },
        { Header: 'Check/EFT #', accessor: 'checkNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7.5, },
        { Header: 'Bank Entity', accessor: 'bankName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
        { Header: 'CUR', accessor: 'currency', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3, },
        { Header: 'Ex.Rate', accessor: 'exRate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 5, },
        { Header: 'Deposit Total', accessor: 'totalAmount', resizable: true, sortable: false, visible: true, initialWidthPercentage: 6.5, },
        { Header: 'Block', accessor: 'block', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3, },
        { Header: 'Draft', accessor: 'draft', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3, },
        { Header: 'Remark', accessor: 'remark', resizable: true, sortable: false, visible: true, initialWidthPercentage: 9, },
        { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.5, },
    ]
};

export const deleteHistoryPaymentSubTable: TableSettings = {
    tableVersion: 10004,
    overflowX: 'hidden',
    overflowY: 'scroll',

    height: '120px',
    useStorage: true,
    flexResizer: true,

    headersColor: 'white',
    columns: [
        { Header: '', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.5, },
        { Header: 'Status', accessor: 'status', resizable: true, sortable: false, visible: true, initialWidthPercentage: 8, },
        { Header: 'Branch', accessor: 'branch', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7, },
        { Header: 'Invoice Date', accessor: 'invoiceDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 15, },
        { Header: 'Invoice #', accessor: 'invoiceNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 15, },
        { Header: 'Account Code', accessor: 'accountCode', resizable: true, sortable: false, visible: true, initialWidthPercentage: 19, },
        { Header: 'Description', accessor: 'description', resizable: true, sortable: false, visible: true, initialWidthPercentage: 20, },
        { Header: 'Received Amount', accessor: 'amount', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10, },
        { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.5, },
    ]
};
